
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.438 4.883c-.454 0-.855-.102-1.204-.305a2.087 2.087 0 01-.796-.836 2.578 2.578 0 01-.282-1.21c0-.443.1-.842.297-1.196C.656.976.937.7 1.297.508 1.657.31 2.063.21 2.516.21c.448 0 .846.099 1.195.297.354.198.628.474.82.828.198.354.297.755.297 1.203 0 .443-.104.844-.312 1.203a2.19 2.19 0 01-.852.836 2.477 2.477 0 01-1.227.305zM2.483.984c-.437 0-.796.144-1.078.43-.281.287-.422.662-.422 1.125 0 .469.141.846.422 1.133.282.286.64.43 1.078.43.448 0 .813-.144 1.094-.43C3.86 3.38 4 3.002 4 2.539c0-.458-.14-.83-.422-1.117-.281-.292-.646-.438-1.094-.438zM13.04.336v2.36h-.766a6.31 6.31 0 00-.335-.86 1.7 1.7 0 00-.336-.5.953.953 0 00-.407-.242 2.21 2.21 0 00-.617-.07H8.29v4.25H9.9c.229 0 .408-.037.539-.11a.85.85 0 00.32-.383c.088-.177.172-.45.25-.82h.734v3.297h-.734c-.078-.354-.162-.62-.25-.797-.089-.182-.195-.31-.32-.383-.12-.078-.3-.117-.54-.117H8.29v3.062c0 .428.031.735.094.922a.84.84 0 00.281.414c.125.094.365.18.719.258V11H5.914v-.383c.323-.083.54-.174.649-.273.109-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 005.914.72V.336h7.125z","fill":"currentColor"}})])
          )
        }
      }
    